import { makeStyles } from '@material-ui/core/styles'

import AvatarIcon from './avatar-icon'

type UserAvatarProps = {
  type: 'user' | 'assistant'
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: 40,
    height: 40,
    borderRadius: 8,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.95rem',
    fontWeight: 600,
    flexShrink: 0,
    boxShadow: theme.shadows[1],
  },
  user: {
    color: '#ffffff',
    background: 'var(--ds-gradient-secondary, linear-gradient(135deg, #253f7f 0%, #344f8f 100%))',
  },
}))

const UserAvatar = ({ type }: UserAvatarProps) => {
  const classes = useStyles()

  if (type === 'assistant') {
    return <AvatarIcon size={40} />
  }

  return (
    <span className={`${classes.root} ${classes.user}`}>👤</span>
  )
}

export default UserAvatar
